import type { TranslationKeys } from "@/hooks/useTranslation/useTranslation"
import type { DashboardWidgetProps } from "../customerWidgetRegistry"
import { SummaryLinkRow } from "./SummaryLinkRow"

const MC_BASE = "/material-compliance"

// Mirrors the supplier dashboard's HandedBackWidget summary-row pattern.
// `status` is the exact query value each row deep-links with — Task 13
// wires `ConformityInboxView` to read it; this task only pins the hrefs.
const ROWS: {
  labelKey: TranslationKeys
  value: (s: DashboardWidgetProps["stats"]) => number
  status: "draft" | "needs_review" | "approved" | "issued"
  warn?: boolean
  // "Issued" here means `issuedQuarter` (THIS quarter), not every issued
  // declaration ever — the extra `issued_period` param narrows the drill-down
  // list to match what this row's number actually counts (Fix B).
  extraQuery?: string
}[] = [
  {
    labelKey: "MC_CSD_CF_DRAFT",
    value: (s) => s.conformity.draft,
    status: "draft",
  },
  {
    labelKey: "MC_CSD_CF_SVHC",
    value: (s) => s.conformity.flaggedSvhc,
    status: "needs_review",
    warn: true,
  },
  {
    labelKey: "MC_CSD_CF_APPROVED",
    value: (s) => s.conformity.approved,
    status: "approved",
  },
  {
    labelKey: "MC_CSD_CF_ISSUED",
    value: (s) => s.conformity.issuedQuarter,
    status: "issued",
    extraQuery: "&issued_period=current_quarter",
  },
]

export function ConformityWidget({ stats }: DashboardWidgetProps) {
  return (
    <div>
      {ROWS.map((row) => (
        <SummaryLinkRow
          key={row.labelKey}
          labelKey={row.labelKey}
          value={row.value(stats)}
          to={`${MC_BASE}/customer-studio/conformity?status=${row.status}${row.extraQuery ?? ""}`}
          warn={row.warn}
        />
      ))}
    </div>
  )
}
